import * as React from 'react'
import {
  Box,
  useColorModeValue as mode,
} from '@chakra-ui/react'
import Layout from '../components/website/Layout'
import Headers from '../components/website/sections/Header/'
import { CourseHero } from '../components/website/legacy/CourseHero'
import { CourseSyllabus } from '../components/website/legacy/syllabus/CourseSyllabus'
import { Pricing } from '../components/website/legacy/pricing/Pricing'
import { Teacher } from '../components/website/legacy/Teacher'
import { LearnDataScience } from '../components/website/legacy/features/LearnDataScience'
import Faq from '../components/website/legacy/Faq'
import Footer from '../components/website/sections/Footer'

const DataScienceLiveCourse = () => {
  return (
    <Layout
      title="Jungle Program – Deep Learning Live Course"
      canonical="https://www.jungleprogram.com/deep-learning-live-course"
      description="Join a 6-week training to practice and gain strong foundations in deep learning and advanced machine learning."
    >
      <Headers />
      <Box bg={mode('gray.50')} pt="5" pb="0" mb="0" overflow="hidden">
        <CourseHero
          level='Advanced'
          duration='6 weeks part time'
          instructor={`Camille Van Hoffelen`}
          instructorImg={`/img/instructor-camille.png`}
          courseName={`Modern Deep Learning`}
          dates={`May 2022`}
          desc={<div>
            <p>
              Join a 6-week training to take your applied and theoretical Deep Learning skills to the next level.
            </p>
            <p>
              Keep up with the state-of-the-art to lead experiments and discussions in your Machine Learning team.
            </p>
            <p>
              Part-time course compatible with your full-time job.
            </p>
          </div>}
          enroll={`https://calendly.com/gauroq/first-call-jungle-program?a1=I'm%20interested%20in:%20Modern%20Deep%20Learning`}
        />
        <LearnDataScience
          title={`Learn Deep Learning`}
          who={`This course is perfect for the Machine Learning student moving past basics, the Software Engineer looking to specialise in Deep Learning, or the Data Scientist trying to keep up with the state-of-the-art.`}
          requirements={`Beginner Data Science skills are required. Students should be comfortable with python, jupyter notebook, and NumPy, Pandas, SciKit-Learn libraries. Basic understand of Machine Learning theory (what's logistic regression?) and practice (how to measure model accuracy?) are also needed.`}
          buttonLabel={``}
          buttonURI={``}
        />
        <CourseSyllabus
          overview={
            {
              'title': 'Detailed course program',
              'subtitle': 'You will learn to wrestle with Deep Learning (DL) methods, and make Neural Networks (NNs) reveal all their secrets.',
              'features': [
                '<div>First, you will build strong theoretical foundations by building NNs from scratch with pytorch.</div>',
                'Then, you will deal with the hands-on challenges of DL: debugging in pytorch, and applying modern optimisation and regularisation methods to ensure successful NN training.',
                'Next, you will explore state-of-the-art model architectures & learning paradigms by delving into DL\'s most popular applications.',
                'With Computer Vision, you will build Convolutional Neural Networks, Generative Adversarial Networks, and discover the power of Transfer Learning. With Natural Language Processing, you will convert words and sentences into vectors, train transformers, and generate text. Then, you will expand your applications with time series modelling, sequence-to-sequence learning, and imitation learning for knowledge graphs.',
                'Finally, the final project will reinforce these skills and allow to focus on one state-of-the-art paper which you will implement and train on a public dataset.'
              ]
            }
          }
          chapters={
            [
              {
                date: 'Week 1',
                name: 'Neural Network Basics',
                desc: 'Explore Neural Network theory from scratch, and put it into practice with Pytorch.',
                features: [
                  {
                    name: 'Neural Networks Pt. 1',
                    desc: ``
                  },
                  {
                    name: 'Neural Networks Pt. 2',
                    desc: ``
                  },
                  {
                    name: 'Pytorch Fundamentals',
                    desc: ``
                  }
                ]
              },
              {
                date: 'Week 2',
                name: 'Neural Networks Training',
                desc: 'Deep dive into Neural Network optimisation and regularisation methods, and debug common training issues in pytorch.',
                features: [
                  {
                    name: 'Debugging',
                    desc: ``
                  },
                  {
                    name: 'Optimisation',
                    desc: ``
                  },
                  {
                    name: 'Regularisation',
                    desc: ``
                  }
                ]
              },
              {
                date: 'Week 3',
                name: 'Computer Vision',
                desc: 'Deep Learning methods applied to image data: learn about CNNs, understand the transfer learning revolution, and discover generative models.',
                features: [
                  {
                    name: 'Convolutional Neural Networks',
                    desc: ``
                  },
                  {
                    name: 'Transfer Learning',
                    desc: ``
                  },
                  {
                    name: 'Variational Auto-Encoders and Generative Adversarial Networks',
                    desc: ``
                  }
                ]
              },
              {
                date: 'Week 4',
                name: 'Natural Language Processing',
                desc: 'Deep Learning methods applied to text data: learn feature representations of symbolic sequences, tackle the almighty transformer, and experiment with generative language models.',
                features: [
                  {
                    name: 'Representation Learning',
                    desc: ``
                  },
                  {
                    name: 'Transformers',
                    desc: ``
                  },
                  {
                    name: 'Autoregressive Generation',
                    desc: ``
                  },
                ]
              },
              {
                date: 'Week 5',
                name: 'Sequences and Graphs',
                desc: 'The best of the rest: apply sequence models to time series data, explore the seq2seq paradigm, and tackle imitation learning with knowledge graphs.',
                features: [
                  {
                    name: 'Sequence-to-Sequence Learning',
                    desc: ``
                  },
                  {
                    name: 'Deep Learning for Time Series',
                    desc: ``
                  },
                  {
                    name: 'Deep Learning for Knowledge Graphs',
                    desc: ``
                  },
                ]
              },
              {
                date: 'Week 6',
                name: 'Final project',
                desc: 'This chapter tests your skills by implementing a state-of-the-art Deep Learning model from literature, and training it on a public dataset.',
                features: [
                  
                ]
              }
            ]
          }
        />
        <Teacher
          name={`Camille Van Hoffelen`}
          desc={<div>
            <p>
              Camille has worked as a <strong>Machine Learning Engineer</strong> for the last 7 years (Seal, DocuSign...),
              with a focus on large scale <strong>Natural Language Processing</strong> systems.
            </p>
            <p>
              Camille graduated with an MSci in Physics from <strong>Imperial College London</strong>,
              before catching the data science bug and diving
              into legal AI with Seal Software, later acquired by <strong>Docusign</strong>.
            </p>
            <p>
              He was a lecturer in Machine Learning at Ilia State University, and remains an avid presenter
              at meetups and hackathons around Europe.
            </p>
            <p>
              Camille is currently the CTO & Co-founder of Watergenics, where he strives to build a sustainable future
              for our blue Planet by augmenting water quality sensors with AI.  
            </p>
          </div>}
          image={`./img/instructor-camille-2.jpg`}
          linkedin={`https://www.linkedin.com/in/camillevanhoffelen/`}
        />
        <Pricing
          name="Modern Deep Learning"
          price="1900"
          pricestroke=""
          duration="Next training: May 2022"
          link="https://calendly.com/gauroq/first-call-jungle-program?a1=I'm%20interested%20in:%20Modern%20Deep%20Learning"
          features={
            [
              'Part-time training',
              'Join a micro-class of < 10 students',
              'Compatible with your full-time job',
              '3 hours of live interactive class per week',
              '3 to 5 hours of coding exercises per week',
              'Demo day & certification of course completion',
              'Connect with other students and learn together',
              'Master the latest tools & languages in machine learning',
              '1:1 calls with the teachers',
              '5-day free trial',
              'Eligible to CPF financing in France 🇫🇷'
            ]
          }
        />
        <Faq price="1900" />
        <Footer />
      </Box>
    </Layout>
  )
}

export default DataScienceLiveCourse